export default {
  landing_state: -1,
  mmenu: {
    active_taxon: 'Lonely',
    location_active: false,
  },
};
